var _defs, _style, _path, _path2, _g, _g2, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _path3, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConectaGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 685 120",
    width: 685,
    height: 120,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AF_LOGO_CONECTA_RGB_1-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 811,
    y1: 60,
    x2: 1771,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff002c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 4.4,
    y1: 59.9,
    x2: 680.2,
    y2: 59.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff002c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f58224"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: #ffffff } \n\t\t.s2 { fill: url(#g2) } \n\t\t.t3 { font-size: 13px;fill: #000000;font-weight: 400;font-family: \"LiberationSans\", \"Liberation Sans\" } \n\t\t.s4 { fill: #ff002c } \n\t\t.s5 { fill: #f58224 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m811-480h960v1080h-960z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m-149-480h960v1080h-960z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s2",
    d: "m623.4 71.6v31.9c0 6.1-4.3 9.7-9 9.7-5.4 0-8.6-3.9-9.1-9-6.3 6.1-15.3 10.3-27.1 10.3-23.3 0-40.9-19.4-40.9-42.9 0-23.9 19.4-42.9 42.9-42.9 24 0 43.2 19 43.2 42.9zm-18.5 0c0-13.6-10.6-24.4-24.2-24.4-13.6 0-24.6 10.8-24.6 24.4 0 13.3 10.8 24.2 24.6 24.2 13.6 0 24.2-10.9 24.2-24.2zm-422.7-0.2c0 23.5-19.2 42.9-43.8 42.9-24.5 0-43.9-19.4-43.9-42.9 0-23.5 19.4-42.7 43.9-42.7 24.6 0 43.8 19.2 43.8 42.7zm-19.6 0c0-13.8-10.2-24.2-24.2-24.2-13.8 0-24.3 10.4-24.3 24.2 0 13.6 10.3 24.4 24.3 24.4 14 0 24.3-10.8 24.2-24.4zm-139.8-0.5c0 12.2 9.5 21 21.7 21h35c5.6 0 9.7 4.3 9.7 9.6 0 5.3-4.1 9.9-9.7 9.9h-33.9c-23 0-41.2-17.6-41.2-40.3 0-23 18.3-40.2 41.2-40.2h33.9c5.6 0 9.7 4.1 9.7 9.5 0 5.4-4.1 9.9-9.7 9.9h-34.8c-11.8 0-21.9 7.7-21.9 20.6zm340.6-2.9c0 7-2.7 10.9-8.4 10.9h-53.5c3.1 10.8 12.4 17.8 23.3 18 6.8 0 12-1.8 17.2-5.8 4.2-2.7 9.4-3.7 12.8 0.9 2.1 3.4 2 8.5-2.2 12.2-5.7 5.6-15.4 10.2-29 10.2-24.6 0-41.8-19.3-41.8-43 0-23.7 17.2-42.7 42.1-42.7 23.7 0 39.5 18.5 39.5 39.3zm-17.2-3.9c-0.6-10.1-10.4-17.8-21.6-17.8-11.1 0-20 7-23.1 17.8zm186.1 27.1c2 2.8 2 8.4-2.5 12.5-7.2 6.8-15.9 10.6-27.4 10.6-20.1 0-38.6-13.8-38.6-42.2v-21.8h-53.8c-11.9 0-21.9 7.7-21.9 20.6 0 12.2 9.5 21 21.7 21h34.9c5.6 0 9.7 4.3 9.7 9.6 0 5.3-4.1 9.9-9.7 9.9h-33.9c-22.9 0-41.2-17.6-41.2-40.3 0-23 18.3-40.2 41.2-40.2h53v-15.4c0-5.6 4.7-10.1 9.9-10.1 5.4 0 9.7 4.5 9.7 10.1v15.4h31.4c5.5 0 9.6 4.1 9.6 9.5 0 5.4-4.1 9.9-9.6 9.9h-31.4v22.9c0 15.3 9.7 22.6 19.3 22.6 7.8 0 11.9-1.8 17.8-6.4 3.4-2.4 9.1-2.4 11.8 1.8zm-260-21.2v33.9c0 5.5-4.1 9.6-9.5 9.6-5.4 0-9.9-4.1-9.9-9.6v-34.8c0-11.9-7.7-21.9-20.6-21.9-12.2 0-21 9.5-21 21.7v35c0 5.5-4.3 9.7-9.7 9.7-5.2 0-9.8-4.2-9.8-9.7v-33.9c0-23 17.5-41.3 40.3-41.3 23 0 40.2 18.3 40.2 41.3zm383-21l22.4 10c1.7 0.8 2.6 2.3 2.6 4 0 1.7-1 3.3-2.7 4l-22.3 10c-2.3 1-4.7-0.1-5.7-2.3-0.9-2.2 0-4.7 2.3-5.5l2-0.8v-10.7l-2-0.8c-2.2-0.9-3.2-3.4-2.3-5.6 1-2.1 3.4-3.3 5.7-2.3zm5.3 16.6l6.6-2.6-6.6-2.6zm19.7 26.8c0 4.2-1.5 7.6-3 9.3-1.6 1.9-4.2 1.9-5.6 0.4-0.9-1.1-1.4-2.7-0.4-4.2 1.3-1.6 1.8-3.3 1.8-5.4 0-5-3.9-8.3-8.4-8.3-4.3 0-8.5 3.1-8.5 8.3 0 1.9 0.5 3.7 1.7 5.2h2.7v-2.3c0-1.9 0.6-3.6 2.9-3.6 1.8 0 3.1 1.7 3.1 3.6v5.8c0 2.4-1.9 3.7-4.2 3.7h-5.2c-1.7 0-3.2-1-4.2-1.9-2.5-2.7-4-6.5-4-10.6 0-8.8 6.5-16 15.6-16 9.3 0 15.7 7.5 15.7 16zm-31.3-50.5c0-2.5 2.1-4.6 4.6-4.6 2.5 0 4.6 2.1 4.6 4.6 0 2.5-2.1 4.5-4.6 4.5-2.4 0-4.6-2-4.6-4.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m1132.6 71.4c0 23.5-19.2 42.9-43.8 42.9-24.5 0-43.9-19.4-43.9-42.9 0-23.5 19.4-42.7 43.9-42.7 24.6 0 43.8 19.2 43.8 42.7zm-19.5 0c0-13.8-10.3-24.2-24.3-24.2-13.8 0-24.4 10.4-24.4 24.2 0 13.6 10.4 24.4 24.4 24.4 14 0 24.3-10.8 24.3-24.4zm-139.9-0.5c0 12.2 9.5 21 21.7 21h35c5.6 0 9.7 4.3 9.7 9.6 0 5.2-4.1 9.9-9.7 9.9h-33.9c-23 0-41.2-17.6-41.2-40.3 0-23 18.2-40.2 41.2-40.2h33.9c5.6 0 9.7 4.1 9.7 9.5 0 5.4-4.1 9.8-9.7 9.8h-34.8c-11.8 0-21.9 7.8-21.9 20.7zm600.6 0.7v31.9c0 6.1-4.3 9.7-9 9.7-5.4 0-8.6-4-9.1-9-6.3 6.1-15.3 10.3-27.1 10.3-23.3 0-40.9-19.4-40.9-42.9 0-23.9 19.4-42.9 42.9-42.9 24 0 43.2 19 43.2 42.9zm-18.5 0c0-13.6-10.6-24.4-24.2-24.4-13.6 0-24.6 10.8-24.6 24.4 0 13.3 10.8 24.2 24.6 24.2 13.6 0 24.2-10.9 24.2-24.2zm-72.6 19.6c2 2.8 2 8.4-2.5 12.5-7.2 6.8-16 10.6-27.5 10.6-20 0-38.5-13.8-38.5-42.2v-21.8h-53.9c-11.8 0-21.9 7.7-21.9 20.6 0 12.2 9.6 21 21.7 21h35c5.6 0 9.7 4.3 9.7 9.6 0 5.2-4.1 9.9-9.7 9.9h-33.9c-22.9 0-41.2-17.6-41.2-40.3 0-23 18.3-40.2 41.2-40.2h53v-15.4c0-5.6 4.6-10.1 9.8-10.1 5.4 0 9.7 4.5 9.7 10.1v15.4h31.4c5.6 0 9.7 4.1 9.7 9.5 0 5.4-4.1 9.8-9.7 9.8h-31.4v23c0 15.3 9.7 22.6 19.4 22.6 7.7 0 11.8-1.8 17.7-6.4 3.5-2.4 9.2-2.4 11.9 1.8zm-168.9-23.2c0 7-2.7 10.9-8.5 10.9h-53.4c3 10.8 12.4 17.8 23.3 18 6.8 0 12-1.8 17.2-5.8 4.2-2.7 9.4-3.7 12.8 0.9 2.1 3.4 1.9 8.5-2.2 12.2-5.7 5.6-15.4 10.2-29 10.2-24.6 0-41.8-19.3-41.8-43 0-23.7 17.2-42.7 42.1-42.7 23.7 0 39.5 18.5 39.5 39.3zm-17.2-3.9c-0.6-10.1-10.4-17.8-21.6-17.8-11.1 0-20 7-23.1 17.8zm-73.9 5.9v33.9c0 5.5-4.1 9.6-9.5 9.6-5.4 0-9.9-4.1-9.9-9.6v-34.8c0-11.9-7.7-21.9-20.6-21.9-12.2 0-21 9.5-21 21.7v35c0 5.5-4.3 9.7-9.7 9.7-5.2 0-9.8-4.2-9.8-9.7v-33.9c0-23 17.6-41.3 40.3-41.3 23 0 40.2 18.3 40.2 41.3zm383-21l22.4 10c1.7 0.8 2.6 2.3 2.6 4 0 1.7-1 3.3-2.7 4l-22.3 10c-2.3 1-4.7-0.1-5.7-2.3-0.9-2.2 0-4.7 2.3-5.5l2-0.8v-10.7l-2-0.8c-2.2-0.9-3.2-3.4-2.3-5.6 1-2.1 3.4-3.3 5.7-2.3zm5.3 16.6l6.6-2.6-6.6-2.6zm19.7 26.8c0 4.2-1.5 7.6-3 9.3-1.6 1.9-4.2 1.9-5.6 0.4-0.9-1.1-1.4-2.7-0.4-4.2 1.3-1.6 1.8-3.3 1.8-5.4 0-5-3.9-8.3-8.4-8.3-4.3 0-8.5 3.1-8.5 8.3 0 1.9 0.5 3.7 1.7 5.2h2.7v-2.3c0-1.9 0.6-3.6 2.9-3.6 1.8 0 3.1 1.7 3.1 3.6v5.8c0 2.4-1.9 3.7-4.2 3.7h-5.2c-1.7 0-3.2-1-4.2-1.9-2.5-2.7-3.9-6.5-3.9-10.6 0-8.8 6.4-16 15.5-16 9.3 0 15.7 7.5 15.7 16zm-31.2-50.5c0-2.5 2-4.6 4.5-4.6 2.5 0 4.6 2.1 4.6 4.6 0 2.5-2.1 4.5-4.6 4.5-2.5 0-4.5-2-4.5-4.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("text", {
    id: "VERMELHO",
    style: {
      transform: "matrix(1,0,0,1,-95.07,430.99)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "VERMELHO\n"))), /*#__PURE__*/React.createElement("text", {
    id: " ",
    style: {
      transform: "matrix(1,0,0,1,185.27,910.99)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "hex: ff002c",
    style: {
      transform: "matrix(1,0,0,1,-36.57,455.99)"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "hex: ff002c\n"))), /*#__PURE__*/React.createElement("text", {
    id: "RGB: 255.0.44 ",
    style: {
      transform: "matrix(1,0,0,1,34.93,480.99)"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "RGB: 255.0.44 \n"))), /*#__PURE__*/React.createElement("text", {
    id: "CMYK: 0.100.86.0",
    style: {
      transform: "matrix(1,0,0,1,125.93,505.99)"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "CMYK: 0.100.86.0\n")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m-105.1 530.8h159.5v26.4h-159.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LARANJA",
    style: {
      transform: "matrix(1,0,0,1,104.505,430.99)"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "LARANJA\n"))), /*#__PURE__*/React.createElement("text", {
    id: " ",
    style: {
      transform: "matrix(1,0,0,1,365.895,910.99)"
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "hex: f58224",
    style: {
      transform: "matrix(1,0,0,1,156.505,455.99)"
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "hex: f58224\n"))), /*#__PURE__*/React.createElement("text", {
    id: "RGB: 245.130.36 ",
    style: {
      transform: "matrix(1,0,0,1,228.005,480.99)"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "RGB: 245.130.36 \n"))), /*#__PURE__*/React.createElement("text", {
    id: "CMYK: 0.60.100.0",
    style: {
      transform: "matrix(1,0,0,1,332.005,505.99)"
    }
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "CMYK: 0.60.100.0\n")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m94.5 530.8h159.4v26.4h-159.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectaGradient);
export default __webpack_public_path__ + "static/media/conecta-gradient.2c2d809ec8d4965084865aefcb723dab.svg";
export { ForwardRef as ReactComponent };